export default "__VITE_ASSET__6LUeOZtd__"